import jquery from 'jquery';

/**
 * @description
 * Восстановление пароля
 *
 * @param {Object} fields - объект с полями.
 * @param {String} fields.email - email, для которого восстанавливаем пароль
 *
 * @return {Promise} - поток выполнения задачи
 */

export default function(fields) {
  var _result = jquery.Deferred();

  jquery.post('/client_account/password/reset.json', fields)
    .then(function(response) {
      if (response.status == 'ok') {
        _result.resolve(response);
      } else {
        response.errors = { email: [ response.message ] };

        _result.reject(response);
      }
    });

  return _result.promise();
}
